import React, { useCallback } from "react";
import { useAnalytics } from "../lib/analytics/analytics";

interface LogoProps {
  homepageURL: string;
  logo: string;
}

export function Logo(props: LogoProps) {
  const { homepageURL, logo } = props;
  const analytics = useAnalytics();

  const onLogoClick = useCallback(
    (e) => {
      analytics.event(
        "Logo Click",
        {
          Source: "WL",
        },
        { onlyProviders: ["mixpanel", "customerio"] }
      );
    },
    [analytics]
  );

  return (
    <a
      className="offering-header-logo-link"
      href={homepageURL}
      onMouseDown={onLogoClick}
    >
      <img className="offering-header-logo" alt="logo" src={logo} />
    </a>
  );
}
